import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Lheader from "../Landingpageheader/Lheader";
import HeroSection from "./HeroSection";
import HeroMarquee from "./HeroMarquee";
import WhatIsMyAptitude from "./WhatIsMyAptitude";
import GridSection from "./GridSection";
import Features from "./Features";
import WhyUslot from "./WhyUslot";
import TestBox from "./TestBox";
import FAQ from "../FAQ/FAQ";
import Testimonials from "./Testimonials";
import Footer from "../Footer/Footer";
import ForWhom from "./ForWhom";
import PathSelectionSection from "./PathSelectionSection";
import Recognitions from "./Recognitions";

const Homepage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectTo = JSON.parse(localStorage.getItem("redirectTo"));
    if (redirectTo) {
      localStorage.removeItem("redirectTo");
      navigate("/home");
    }
  }, [navigate]);

  return (
    <main className="bg-white min-h-screen">
        <Lheader />
        <HeroSection />
        {/* <HeroMarquee /> */}
        {/* <WhatIsMyAptitude /> */}
        <ForWhom />
        <GridSection />
        <Features />
        <WhyUslot />
        <TestBox />
        <PathSelectionSection />
        <Recognitions />
        <Testimonials />
        <FAQ />
        <Footer />
    </main>
  );
};

export default Homepage;
